const COMMENTS = [
  {
    id: 1,
    name: '吃瓜群众老王',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20coral%20and%20cream%20colors%2C%20minimalist%20style%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting%2C%20no%20text&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    time: '3小时前',
    content: '这个网站导航太实用了！之前找吃瓜爆料网站要到处搜，现在一个页面全搞定，更新也很及时，已经收藏了。',
    likes: 256,
  },
  {
    id: 2,
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20avatar%2C%20amber%20and%20cream%20colors%2C%20minimalist%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20lighting%2C%20no%20text%2C%20editorial%20quality&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    time: '6小时前',
    content: '作为资深吃瓜人，这个站点的分类做得很清晰，娱乐圈、网红圈、综艺分门别类，找起来特别方便。推荐给了好多朋友。',
    likes: 189,
  },
  {
    id: 3,
    name: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20coral%20colors%2C%20minimalist%20style%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting%2C%20no%20text%2C%20editorial&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    time: '12小时前',
    content: '每日更新的排名榜单很有参考价值，能快速看出哪些网站最近比较活跃。希望继续增加更多海外吃瓜站点的收录。',
    likes: 132,
  },
  {
    id: 4,
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20avatar%2C%20amber%20colors%2C%20minimalist%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20lighting%2C%20no%20text%2C%20editorial%20quality&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    time: '1天前',
    content: '移动版体验也很流畅，躺床上刷吃瓜太舒服了。人工审核这点很赞，不用担心点到乱七八糟的网站。',
    likes: 97,
  },
  {
    id: 5,
    name: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20portrait%20avatar%2C%20soft%20coral%20colors%2C%20minimalist%20style%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting%2C%20no%20text%2C%20editorial&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    time: '2天前',
    content: '2025年吃瓜网站越来越多，有这个导航站省心多了。专题文章写得也不错，能深入了解到不少行业内的幕后故事。',
    likes: 74,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
            用户声音
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2">看看大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    width="80"
                    height="80"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}